var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronLeftDoubleSvg from './chevron-left-double.icon.svg';
export const ChevronLeftDoubleIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronLeftDoubleSvg });
};
_react_refresh_temp_1 = ChevronLeftDoubleIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronLeftDoubleIcon");
